import React from 'react';

import { trendDown, trendFlat, trendUp } from '@/assets/icons';
import { Trend } from '@/graphql';
import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import styles from './TrendIcon.module.scss';

type TrendIconProps = { trend: Trend };

export const TrendIcon: React.FC<TrendIconProps> = ({ trend }) => {
	switch (trend) {
		case Trend.Up:
			return (
				<SvgIcon
					component={trendUp}
					classes={{
						root: classNames([styles['up']]),
					}}
				/>
			);
		case Trend.Down:
			return (
				<SvgIcon
					component={trendDown}
					classes={{
						root: classNames([styles['down']]),
					}}
				/>
			);
		case Trend.Flat:
			return (
				<SvgIcon
					component={trendFlat}
					classes={{
						root: classNames([styles['flat']]),
					}}
				/>
			);
		default:
			return null;
	}
};
